const faviconOverride = (className) => {
  const faviconId = `favicon_${className}`;
  const faviconHref = `https://cdn.pendlerportal.de/${className}/favicon.ico`;

  if (document.head.querySelector(`link[id="${faviconId}"]`)) {
    return;
  }

  // Remove default favicon links so the derivative icon takes precedence.
  // Browsers prefer larger icons (e.g. 32x32 default over 16x16 CDN) when
  // multiple rel="icon" links are present.
  document.head
    .querySelectorAll('link[rel="icon"], link[rel="shortcut icon"]')
    .forEach((link) => {
      if (!link.id?.startsWith('favicon_')) {
        link.remove();
      }
    });

  const link = document.createElement('link');
  link.id = faviconId;
  link.type = 'image/x-icon';
  link.rel = 'icon';
  link.href = faviconHref;
  document.head.appendChild(link);
};
export default faviconOverride;
